module.exports = __webpack_public_path__ + "img/low-fi.e568cf8d.svg";